module.exports = __webpack_public_path__ + "img/slider-5.cf98ebe3.jpg";